module.exports = __webpack_public_path__ + "static/teamBG.2f8aa5c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teamBG.jpg
// module id = 851
// module chunks = 21571696733600